module.export = {
  require: v => !!v || '必須項目です',
  kana: v => !/[^ぁ-ん]/.test(v) || '平仮名のみ入力有効です',
  alphabetOnly: v => !/[^A-z]/.test(v) || '英字のみ入力有効です',
  numberOnly: v => !/[^0-9]/.test(v) || '数字のみ入力有効です',
  email: v => {
    const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    return pattern.test(v) || '妥当なEメールではありません'
  }
}
